import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from './services/toast.service';
import { FrontendErrorReporterService } from './frontend-error-reporter.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
  private platformId = inject(PLATFORM_ID);
  private reporter = inject(FrontendErrorReporterService);

  constructor(private toast: ToastService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const isFavoritesAuthError = req.url.includes('/api/favorites') && (error.status === 401 || error.status === 403);
        if (isFavoritesAuthError) {
          return throwError(() => error);
        }

        const isPublicProfileNotFound = /\/api\/users\/[^/]+\/public$/.test(req.url) && error.status === 404;
        if (isPublicProfileNotFound) {
          return throwError(() => error);
        }

        const isPublicConfigTransientError = req.url.includes('/api/config') && error.status === 0;
        if (isPublicConfigTransientError) {
          return throwError(() => error);
        }

        console.error('HTTP Error:', error.status, error.message, error.error);
        if (isPlatformBrowser(this.platformId)) {
          this.reporter.report({
            kind: 'http_error',
            message: error.message,
            status: error.status,
            method: req.method,
            request_url: req.urlWithParams,
            details: { error: this.safeError(error.error) },
          });
        }
        // SSR must not render transient snackbar markup into HTML during prerender/build.
        if (isPlatformBrowser(this.platformId)) {
          if (error.status >= 500) {
            this.toast.error('Ошибка сервера. Попробуйте позже.');
          } else if (error.status === 0) {
            this.toast.error('Нет соединения с сервером.');
          }
        }
        return throwError(() => error);
      })
    );
  }

  private safeError(value: unknown): unknown {
    if (value === null || value === undefined) return value;
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return value;
    try {
      return JSON.parse(JSON.stringify(value));
    } catch {
      return String(value);
    }
  }
}
